import { mutatorAction } from "satcheljs";

import { ImportJobsStore } from "../store/ImportJobsStore";

export const setImportDialogErrorMessage =  mutatorAction("setImportDialogErrorMessage", (message: string) => {
    ImportJobsStore().dialogErrorMessage = message;
});